import { $, addAction, INIT } from '@situation/setdesign.util';
import { sceneController, getSceneDuration } from '../../shared/animations/setup';

/* global ScrollMagic, TweenMax */
addAction(INIT, () => {
    $('.horizontal-animation').each((index, element) => {
        const options = { triggerElement: element, triggerHook: 1, duration: getSceneDuration.bind(element) };
        const scene = new ScrollMagic.Scene({ ...options });
        scene.setTween(TweenMax.fromTo(element, 1, { x: '-10%', opacity: 0 }, { x: '1%', opacity: 1 }));
        scene.addTo(sceneController);
    });
});
